import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useLayoutEffect,
} from "react";
import InputField from "../../../../components/Input/InputField";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import Form from "../../../../components/Form/Form";
import MasterCreationFooter from "../../../../components/Footer/Master_Footer/MasterCreationFooter";
import { VoucherSalesPurchaseInputRow } from "./VoucherSalesPurchaseInputRow";
import { PaymentAllocation } from "./PaymentAllocation";
import {
  currencyFormate,
  validateBackDatedVoucher,
} from "../../../../components/Date_Formate_Utilitiy/Index";
import Total_Amount_Row_Sell_Purchase from "../../../../components/Total_Amount/Total_Amount_Row_Sell_Purchase";
import TableHeaderSalePurchase from "../../../../components/Table/TableHeaderSalePurchase";
import DispatchDetails from "../voucher_modal/DispatchDetails";
import OrderDetails from "../voucher_modal/OrderDetails";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import LedgerCreate from "pages/gatewayoftally/master/create/accounting_masters/Ledger";
import GodownCreate from "pages/gatewayoftally/master/create/Inventory_masters/GoDown";
import StockItemCreate from "pages/gatewayoftally/master/create/Inventory_masters/StockItem";
import {
  prepareFormData,
  useFormHandler,
} from "components/Custom_Hooks/useFormHandler";
import useClickOutside from "components/Custom_Hooks/useClickOutsSide";
import {
  closeModal,
  contraVoucherCreate,
  contraVoucherUpdate,
  openModal,
  contraLedgerListing,
  godownList,
  stockItemList,
} from "redux/actions/action-creator";
import { useSale } from "components/Custom_Hooks/useSale";
import { useNavigate } from "react-router-dom";

const array_avai_not_avai = [
  { id: 1, name: "Not Available" },
  { id: 2, name: "Available" },
];

// 🔹 1️⃣ Particular
const particularSlugs = [
  "branchdivisions",
  "sundry-debtors",
  "sundry-creditors",
];

// 🔹 3️⃣ Item Ledger
const itemLedgerSlugs = [
  /*"current-assets",
    "current-liabilities",*/
  "direct-expenses",
  "direct-incomes",
  "duties-taxes",
  "indirect-expenses",
  "indirect-incomes",
  "sales-accounts",
];
// 🔹 4️⃣ Payment Ledger
const paymentLedgerSlugs = [
  "bank-account",
  "bank-od-ac",
  "cashinhand",
];

const requiredFields = [
  { field: "voucher_type_name", message: "Voucher type is required" },
  // { field: "serial_no", message: "Serial number is required" },
  { field: "create_date", message: "Date is required" },
];

const Sales = ({
  data,
  setData,
  initialState,
  loading,
  isAlter,
  isView,
  isDuplicate,
}) => {
  const inputFields = [
    {
      id: "1",
      label: "",
      name: "serial_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "2",
      label: "Date",
      name: "create_date",
      type: "text",
      isRequired: true,
    },
    {
      id: "3",
      label: `${data?.select_type_of_voucher?.toLowerCase() === "sale" ? "Reference No." : "Orignal Invoice No."}`,
      name: "supplier_ref_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "4",
      label: "Date",
      name: "date_payment",
      type: "text",
      isRequired: true,
    },
    {
      id: "5",
      label: "Buyer (Bill to)",
      name: "party_bill_to",
      type: "text",
      isRequired: true,
    },
    {
      id: "6",
      label: "Current Balance",
      name: "partry_bill_to_current_balance",
      type: "text",
      isRequired: true,
    },
    {
      id: "7",
      label: "Mailing Name",
      name: "party_bill_to_mailing_name",
      type: "text",
      isRequired: true,
    },
    {
      id: "8",
      label: "City",
      name: "bill_to_city",
      type: "text",
      isRequired: true,
    },
    {
      id: "9",
      label: "Contact",
      name: "bill_to_contact",
      type: "text",
      isRequired: true,
    },
    {
      id: "10",
      label: "Consignee (Ship to)",
      name: "party_ship_to",
      type: "text",
      isRequired: true,
    },
    {
      id: "11",
      label: "Current Balance",
      name: "party_ship_to_current_balance",
      type: "text",
      isRequired: true,
    },
    {
      id: "12",
      label: "Mailing Name",
      name: "party_ship_to_mailing_name",
      type: "text",
      isRequired: true,
    },
    {
      id: "13",
      label: "City",
      name: "ship_to_city",
      type: "text",
      isRequired: true,
    },
    {
      id: "14",
      label: "Contact",
      name: "ship_to_contact",
      type: "text",
      isRequired: true,
    },
    {
      id: "15",
      label: "Location",
      name: "location",
      type: "text",
      isRequired: true,
    },
    {
      id: "16",
      label: `${data?.select_type_of_voucher?.toLowerCase() === "sales" ? "Sales Ledger Cr" : "Ledger Account Dr"}`,
      name: "sale_purchase_ledger_account",
      type: "text",
      isRequired: true,
    },
    {
      id: "17",
      label: `${data?.select_type_of_voucher?.toLowerCase() === "sales" ? "Despatch Details" : "Receipt Details"}`,
      name: "dispatch_detail",
      type: "text",
      isRequired: true,
    },
    {
      id: "18",
      label: "Delivery Note No",
      name: "delivery_note_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "19",
      label: "Dispatch Doc No",
      name: "dispatch_doc_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "20",
      label: "Dispatched Through",
      name: "dispatch_through",
      type: "text",
      isRequired: true,
    },
    {
      id: "21",
      label: "Destination",
      name: "destination",
      type: "text",
      isRequired: true,
    },
    {
      id: "22",
      label: "Carrier Name/Agent",
      name: "carrier_name_agent",
      type: "text",
      isRequired: true,
    },
    {
      id: "23",
      label: "Mobile Number",
      name: "carrier_mobile_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "24",
      label: "Bill of Lading/LR/RR No",
      name: "bill_of_loading",
      type: "text",
      isRequired: true,
    },
    {
      id: "25",
      label: "Dispatch Date",
      name: "dispatch_date",
      type: "text",
      isRequired: true,
    },
    {
      id: "26",
      label: "Vehical Number",
      name: "vehicle_number",
      type: "text",
      isRequired: true,
    },
    {
      id: "27",
      label: `${data?.select_type_of_voucher?.toLowerCase() === "sale" ? "Sales Order Details" : "Order Details"}`,
      name: "order_detail",
      type: "text",
      isRequired: true,
    },
    {
      id: "28",
      label: "Order No",
      name: "order_no",
      type: "text",
      isRequired: true,
    },
    {
      id: "29",
      label: "Mode of Term Payment",
      name: "mode_term_payment",
      type: "text",
      isRequired: true,
    },
    {
      id: "30",
      label: "Other Reference",
      name: "other_reference",
      type: "text",
      isRequired: true,
    },
    {
      id: "31",
      label: "Term of Delivery",
      name: "term_of_delivery",
      type: "text",
      isRequired: true,
    },
    {
      id: "32",
      label: "Narration",
      name: "narration",
      type: "text",
      isRequired: true,
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const inputRefs = {
    voucher_type_name: useRef(null),
    serial_no: useRef(null),
    create_date: useRef(null),
    supplier_ref_no: useRef(null),
    date_payment: useRef(null),
    party_bill_to: useRef(null),
    party_bill_to_mailing_name: useRef(null),
    bill_to_city: useRef(null),
    bill_to_contact: useRef(null),
    party_ship_to: useRef(null),
    party_ship_to_mailing_name: useRef(null),
    ship_to_city: useRef(null),
    ship_to_contact: useRef(null),
    location: useRef(null),
    sale_purchase_ledger_account: useRef(null),
    dispatch_detail: useRef(null),
    delivery_note_no: useRef(null),
    dispatch_doc_no: useRef(null),
    dispatch_through: useRef(null),
    destination: useRef(null),
    carrier_name_agent: useRef(null),
    carrier_mobile_no: useRef(null),
    bill_of_loading: useRef(null),
    dispatch_date: useRef(null),
    vehicle_number: useRef(null),
    order_detail: useRef(null),
    order_no: useRef(null),
    mode_term_payment: useRef(null),
    other_reference: useRef(null),
    term_of_delivery: useRef(null),
    narration: useRef(null),
  };

  const dynamicInputRef = useRef({});
  const dynamicInputRef_expenses = useRef({});
  const dynamicInputRef_payment_allocation = useRef({});

  const modal_state = useSelector((state) => state.common.modal_state);
  const { userData } = useSelector((state) => state.auth);

  const [nameInput, setNameInput] = useState(null);
  const [sales_ledger_list, setsales_ledger_list] = useState([]);
  const [
    party_bill_and_ship_to_ledger_list,
    setparty_bill_and_ship_to_ledger_list,
  ] = useState([]);
  const [itemLedgerData, setitemLedgerData] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [isListLoading, setIsListLoading] = useState(false);
  const [isGodownLoading, setIsGodownLoading] = useState(false);
  const [isItemLoading, setIsItemLoading] = useState(false);
  const [payment_allocation_ledger_list, setpayment_allocation_ledger_list] =
    useState([]);
  const [godownLocation, setGodownLocation] = useState({
    state: [],
    item: [],
  });

  const dropdownConfig = {
    party_bill_to: {
      title: "List of Ledger",
      input_id: "party_bill_to_ledger_id",
      data: party_bill_and_ship_to_ledger_list,
    },
    party_ship_to: {
      title: "List of Ledger",
      input_id: "party_ship_to_ledger_id",
      data: party_bill_and_ship_to_ledger_list,
    },
    location: {
      title: "List of Godown",
      input_id: "location_id",
      data: godownLocation?.state || [],
    },
    sale_purchase_ledger_account: {
      title: "List of Ledger",
      input_id: "sales_ledger_order_id",
      data: sales_ledger_list,
    },
    dispatch_detail: { title: "Dispatch Details", data: array_avai_not_avai },
    order_detail: { title: "Order Details", data: array_avai_not_avai },
  };

  const {
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    setSubmitConfirm,
    submitConfirm,
    handleItemUpdate,
    handleDynamicFocus,
    handleDropdownClick,
    handleDropdownDynamicClick,
    handleDynamicBlur,
  } = useSale({
    data,
    setData,
    contra_account_ledger_list: party_bill_and_ship_to_ledger_list || [],
    validations: {},
    inputRefs: inputRefs,
    dynamicInputRef: dynamicInputRef,
    setNameInput,
    dynamicInputRef_expenses: dynamicInputRef_expenses,
    dynamicInputRef_payment_allocation: dynamicInputRef_payment_allocation,
    isView: isView,
    isAlter: isAlter,
  });

  useEffect(() => {
    if (loading) return;

    const isManual = data.method_of_voucher_number?.toLowerCase() === "manual";
    let targetRef = isManual ? inputRefs?.serial_no : inputRefs?.create_date;
    if (
      targetRef === inputRefs?.create_date &&
      userData?.allowed_back_dated === "No"
    ) {
      targetRef = inputRefs?.supplier_ref_no;
    }

    const focusTimer = setTimeout(() => {
      if (targetRef?.current) {
        targetRef.current.focus();
        if (targetRef.current.select) {
          targetRef.current.select();
        } else if (
          targetRef.current.setSelectionRange &&
          targetRef.current.value
        ) {
          targetRef.current.setSelectionRange(
            0,
            targetRef.current.value.length,
          );
        }
        setNameInput(targetRef);
      }
    }, 200);

    return () => clearTimeout(focusTimer);
  }, [data?.method_of_voucher_number, data?.voucher_type_name, loading]);

  useLayoutEffect(() => {
    if (window.isRestoringVoucherFocus) return;

    // Only block refocus if a "standard" blocking modal is open
    const standardModals = [
      "ledgerCreate",
      "godownCreateVoucher",
      "stockItemCreate",
      "period",
      "changeMode",
      "configure",
      "voucherTypeNameSelect",
      "dispatchDetails",
      "orderDetails",
      "otherVoucher",
      "create_group_under",
      "create_under",
      "create_stock_cat",
      "create_stock_company",
      "create_unit",
    ];
    const isDOMModalOpen = !!(
      document.querySelector(".modal_link") ||
      document.querySelector(".modal_message")
    );
    const isBlockingModalOpen =
      standardModals.some((modal) => modal_state?.[modal]) || isDOMModalOpen;

    if (isBlockingModalOpen || submitConfirm) return;

    if (nameInput?.current) {
      nameInput.current.focus();
    } else if (nameInput?.focus) {
      nameInput.focus();
    }
  }, [modal_state, nameInput, submitConfirm]);

  const API_Function = useCallback(async () => {
    setIsListLoading(true);
    try {
      /*const group_ids_single_string = [
                0, 9, 13,
                26,
                3, 10, 14, 15, 11, 17, 18, 26,
                4, 21,
                5,
                9, 13
            ]
                .map(i => userData?.group_data[i]?.id)
                .filter(Boolean)                 // undefined/null remove
                .filter((id, index, arr) => arr.indexOf(id) === index) // duplicates remove
                .join(",");*/

      const group_ids_single_string = (userData?.group_data || [])
        .map((group) => group.id)
        .filter(Boolean) // remove null/undefined/0 if needed
        .filter((id, index, arr) => arr.indexOf(id) === index) // remove duplicates
        .join(",");

      const formdata = new FormData();
      formdata.append("company_id", userData?.company_id);
      formdata.append("group_ids", group_ids_single_string);
      const response = await dispatch(contraLedgerListing(formdata));
      if (response.status) {
        const groups = userData?.group_data || [];

        // Helper to get recursive slugs based on name-based 'under' relation
        const getExpandedSlugs = (baseSlugs) => {
          const allSlugs = new Set(baseSlugs);
          const allNames = new Set();

          // Initial names from base slugs
          groups.forEach((g) => {
            if (baseSlugs.includes(g?.slug)) {
              const name = g?.name.toLowerCase().trim();
              if (name) allNames.add(name);
            }
          });

          let currentNames = [...allNames];
          let depth = 0;

          while (currentNames.length > 0 && depth < 5) {
            const childGroups = groups.filter(
              (g) =>
                g?.under &&
                currentNames.includes(g?.under.toLowerCase().trim()) &&
                !allNames.has(g?.name.toLowerCase().trim()),
            );

            if (childGroups.length === 0) break;

            const nextNames = [];
            childGroups.forEach((g) => {
              if (g?.slug) allSlugs.add(g?.slug);
              const name = g?.name?.toLowerCase().trim();
              if (name) {
                allNames.add(name);
                nextNames.push(name);
              }
            });
            currentNames = nextNames;
            depth++;
          }
          return [...allSlugs];
        };

        const filterBySlug = (slugArray) =>
          response.data.filter((g) => slugArray.includes(g.group_slug));

        const expandedParticularSlugs = getExpandedSlugs(particularSlugs);
        const expandedSalesSlugs = getExpandedSlugs(["sales-accounts"]);
        const expandedItemSlugs = getExpandedSlugs(itemLedgerSlugs);
        const expandedPaymentSlugs = getExpandedSlugs(paymentLedgerSlugs);

        setparty_bill_and_ship_to_ledger_list(
          filterBySlug(expandedParticularSlugs),
        );
        setsales_ledger_list(filterBySlug(expandedSalesSlugs));
        setitemLedgerData(filterBySlug(expandedItemSlugs));
        setpayment_allocation_ledger_list(filterBySlug(expandedPaymentSlugs));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsListLoading(false);
    }
  }, [dispatch, userData?.company_id, userData?.group_data]);

  const getGodownList = useCallback(async () => {
    setIsGodownLoading(true);
    try {
      const formdata = new FormData();
      formdata.append("company_id", userData?.company_id);
      const response = await dispatch(godownList(formdata));
      if (response.status) {
        const data_with_any = [{ id: "any", name: "Any" }, ...response?.data];
        setGodownLocation({
          state: data_with_any || [],
          item: response?.data || [],
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsGodownLoading(false);
    }
  }, [dispatch, userData?.company_id]);

  const getItemList = useCallback(async () => {
    setIsItemLoading(true);
    try {
      const formdata = new FormData();
      formdata.append("company_id", userData?.company_id);
      const response = await dispatch(stockItemList(formdata));
      if (response.status) {
        setItemList(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsItemLoading(false);
    }
  }, [dispatch, userData?.company_id]);

  useEffect(() => {
    if (!userData?.company_id) return;
    API_Function();
  }, [userData?.company_id, modal_state?.ledgerCreate, API_Function]);

  useEffect(() => {
    if (!userData?.company_id) return;
    getGodownList();
  }, [userData?.company_id, modal_state?.godownCreateVoucher, getGodownList]);

  useEffect(() => {
    if (!userData?.company_id) return;
    getItemList();
  }, [userData?.company_id, modal_state?.stockItemCreate, getItemList]);

  useEffect(() => {
    if (isAlter && itemList.length > 0 && data?.data_item?.length > 0) {
      const needsMapping = data.data_item.some(
        (item) => item.item_id && (!item.unit_name || item.unit_name === ""),
      );
      if (needsMapping) {
        const separateCompoundUnits = (mainUnitName, alternateUnitName) => {
          const units = [];
          const extractUnitsFromString = (unitString) => {
            if (
              !unitString ||
              unitString === "Not Applicable" ||
              unitString === ""
            )
              return [];
            const match = unitString.match(/(\w+)\s+of\s+(\d+)\s+(\w+)/i);
            if (match) {
              const [, containerUnit, quantity, baseUnit] = match;
              return [
                { name: containerUnit, id: `${containerUnit}_container` },
                { name: baseUnit, id: `${baseUnit}_base` },
              ];
            } else {
              return [{ name: unitString, id: `${unitString}_simple` }];
            }
          };
          units.push(...extractUnitsFromString(mainUnitName));
          units.push(...extractUnitsFromString(alternateUnitName));
          return units.filter(
            (unit, index, self) =>
              index === self.findIndex((u) => u.name === unit.name),
          );
        };

        setData((prev) => ({
          ...prev,
          data_item: prev.data_item.map((item) => {
            if (item.item_id && (!item.unit_name || item.unit_name === "")) {
              const matchedMasterItem = itemList.find(
                (master) => String(master.id) === String(item.item_id),
              );
              if (matchedMasterItem) {
                return {
                  ...item,
                  is_unit_available:
                    matchedMasterItem.unit_name &&
                    matchedMasterItem.unit_name !== "Not Applicable" &&
                    matchedMasterItem.unit_name !== ""
                      ? true
                      : false,
                  item_units: separateCompoundUnits(
                    matchedMasterItem.unit_name,
                    matchedMasterItem.alt_unit_name,
                  ),
                  unit_name: matchedMasterItem.unit_name,
                  alt_unit_name: matchedMasterItem.alt_unit_name,
                  where_unit: matchedMasterItem.where_unit,
                  where_alternate_unit: matchedMasterItem.where_alternate_unit,
                  where_unit_name: matchedMasterItem.where_unit_name,
                  where_alternate_unit_name:
                    matchedMasterItem.where_alternate_unit_name,
                };
              }
            }
            return item;
          }),
        }));
      }
    }
  }, [itemList, isAlter, data?.data_item]);

  const validateForm = () => {
    for (let { field, message } of requiredFields) {
      if (!data?.[field] || data[field].toString().trim() === "") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        focusOnField(field);
        return false;
      }
    }

    // Validate "Bill to"
    if (
      !data?.party_bill_to ||
      data.party_bill_to.toString().trim() === "" ||
      data.party_bill_to === "Not Applicable" ||
      data.party_bill_to === "End of List"
    ) {
      toast.error("Bill to is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("party_bill_to");
      return false;
    }

    // Validate "Ship to"
    if (
      !data?.party_ship_to ||
      data.party_ship_to.toString().trim() === "" ||
      data.party_ship_to === "Not Applicable" ||
      data.party_ship_to === "End of List"
    ) {
      toast.error("Ship to is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("party_ship_to");
      return false;
    }

    // Validate "Location"
    if (
      !data?.location ||
      data.location.toString().trim() === "" ||
      data.location === "Not Applicable" ||
      data.location === "End of List"
    ) {
      toast.error("Location is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("location");
      return false;
    }

    // Validate "Ledger Account"
    if (
      !data?.sale_purchase_ledger_account ||
      data.sale_purchase_ledger_account.toString().trim() === "" ||
      data.sale_purchase_ledger_account === "Not Applicable" ||
      data.sale_purchase_ledger_account === "End of List"
    ) {
      const ledgerLabel =
        data?.select_type_of_voucher?.toLowerCase() === "sale"
          ? "Sales Ledger"
          : "Ledger Account";
      toast.error(`${ledgerLabel} is required`, {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("sale_purchase_ledger_account");
      return false;
    }

    if (userData?.allowed_back_dated === "Yes" && userData?.cut_off_date) {
      if (!validateBackDatedVoucher(data?.create_date, userData.cut_off_date)) {
        toast.error("Back date entry not allowed", {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        focusOnField("create_date");
        return false;
      }
    }

    return validateVoucherEntries();
  };

  // Helper function to focus on a specific field
  const focusOnField = (fieldName) => {
    const currentRefs = inputRefs;
    if (currentRefs?.[fieldName]?.current) {
      setTimeout(() => {
        currentRefs[fieldName].current.focus();
        if (currentRefs[fieldName].current.value) {
          currentRefs[fieldName].current.setSelectionRange(
            0,
            currentRefs[fieldName].current.value.length,
          );
        }
      }, 100);
    }
  };

  // Helper function to focus on dynamic field
  const focusOnDynamicField = (fieldName, index = 0) => {
    const firstRowId = data?.data_item?.[index]?.id;
    const targetRef =
      (typeof firstRowId !== "undefined" &&
        dynamicInputRef?.current?.[firstRowId]?.[fieldName]) ||
      dynamicInputRef?.current?.[`${fieldName}${index}`];

    if (!targetRef) return;

    setTimeout(() => {
      targetRef.focus();
      if (targetRef.value) {
        targetRef.setSelectionRange(0, targetRef.value.length);
      }
    }, 100);
  };

  // Validate Purchase/Sales voucher entries
  const validateVoucherEntries = () => {
    const hasItemEntries = (data.data_item || []).some(
      (item) =>
        item?.item_name &&
        item.item_name.trim() !== "" &&
        item.item_name !== "End of List" &&
        parseFloat(String(item.item_amt || "0").replace(/,/g, "")) > 0,
    );

    if (!hasItemEntries) {
      toast.error(
        "Name of Item is required (at least one valid item entry with amount greater than 0)",
        {
          position: toast.POSITION.TOP_CENTER,
        },
      );
      setSubmitConfirm("");
      // Focus on the first item name field as a fallback
      focusOnDynamicField("item_name", 0);
      return false;
    }

    // Check if total amount is greater than 0
    const totalAmount =
      parseFloat(String(data.total_amount_item || "0").replace(/,/g, "")) || 0;

    if (totalAmount <= 0) {
      toast.error("Total amount must be greater than 0", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      // Focus on the first amount field
      focusOnDynamicField("item_amt", 0);
      return false;
    }

    const paymentAllocatedTotal = (data.payment_allocation || []).reduce(
      (sum, row) => {
        const hasSelectedLedger =
          row?.payment_ledger_account_id ||
          (row?.payment_ledger_account &&
            row.payment_ledger_account !== "Not Applicable" &&
            row.payment_ledger_account !== "End of List");

        if (!hasSelectedLedger) return sum;

        const amount =
          parseFloat(
            String(row?.payment_ledger_amount || "0").replace(/,/g, ""),
          ) || 0;
        return sum + amount;
      },
      0,
    );

    const partyAmount =
      parseFloat(
        String(data.total_amount_allocate_party || "0").replace(/,/g, ""),
      ) || 0;

    if (partyAmount < 0) {
      toast.error("Total Dr must be equal to Total Cr", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("party_bill_to");
      return false;
    }

    const totalDr = paymentAllocatedTotal + partyAmount;
    const totalCr = totalAmount;

    if (Math.abs(totalDr - totalCr) > 0.01) {
      toast.error("Total Dr must be equal to Total Cr", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnField("party_bill_to");
      return false;
    }

    return true;
  };

  const resetForm = useCallback(async () => {
    setSubmitConfirm("");

    const fieldsToPreserve = [
      "period_key",
      "create_date",
      "voucher_type_name",
      "voucher_type_id",
      "select_type_of_voucher",
      "method_of_voucher_number",
      "day_name",
    ];

    // Helper function to build reset state
    const buildResetState = (prev) => ({
      ...initialState,
      company_id: userData?.company_id,
      data: initialState.data,
      // Preserve specified fields from previous state
      ...fieldsToPreserve.reduce((acc, field) => {
        acc[field] = prev?.[field] ?? "";
        return acc;
      }, {}),
    });
    setData((prev) => buildResetState(prev));
  }, [setData, userData?.company_id, initialState]);

  const {
    handleSubmit,
    loading: submitting,
    handleFocusReset,
  } = useFormHandler({
    validateForm,
    prepareFormData: () => {
      const cleanNumeric = (val) => {
        const raw = String(val || "").trim();
        if (!raw) return "";

        const hasCr = /\bcr\b/i.test(raw);
        const hasDr = /\bdr\b/i.test(raw);
        const numericOnly = raw
          .replace(/,/g, "")
          .replace(/\b(cr|dr)\b/gi, "")
          .trim();

        if (numericOnly === "") return "";

        const parsed = Number(numericOnly);
        if (Number.isNaN(parsed)) return numericOnly;

        if (hasCr) return String(-Math.abs(parsed));
        if (hasDr) return String(Math.abs(parsed));
        return String(parsed);
      };

      const isMaintainBillByBillEnabled = (ledger) =>
        String(
          ledger?.maintain_balance_bill_by_bill ||
            ledger?.maintain_bill_by_bill ||
            "No",
        ).toLowerCase() === "yes";

      const findLedgerByIdOrName = (ledgerList, ledgerId, ledgerName) =>
        (ledgerList || []).find((ledger) => {
          const currentId = String(
            ledger?.id ||
              ledger?.ledger_id ||
              ledger?.payment_ledger_account_id ||
              "",
          );
          const currentName = String(
            ledger?.ledger_name || ledger?.name || "",
          ).toLowerCase();
          const targetId = String(ledgerId || "");
          const targetName = String(ledgerName || "").toLowerCase();

          return (
            (targetId && currentId === targetId) ||
            (targetName && currentName === targetName)
          );
        });

      const referenceBase = (() => {
        const voucherCode = String(
          data?.voucher_type_name || data?.select_type_of_voucher || "VCH",
        )
          .replace(/[^a-zA-Z]/g, "")
          .toUpperCase()
          .slice(0, 3);
        const dateCode = String(data?.create_date || "")
          .replace(/[^0-9]/g, "")
          .slice(-8);
        const serialCode = String(
          data?.supplier_ref_no || data?.serial_no || "",
        )
          .replace(/\s+/g, "")
          .replace(/[^a-zA-Z0-9/_-]/g, "")
          .slice(0, 20);

        return [voucherCode || "VCH", dateCode || "DATE", serialCode || "AUTO"]
          .filter(Boolean)
          .join("-");
      })();

      const selectedPartyLedger = findLedgerByIdOrName(
        party_bill_and_ship_to_ledger_list,
        data?.party_bill_to_ledger_id,
        data?.party_bill_to,
      );
      const isPartyBillByBill =
        isMaintainBillByBillEnabled(selectedPartyLedger);

      const filteredPaymentAllocation = (data.payment_allocation || [])
        .filter(
          (item) =>
            item.payment_ledger_account &&
            item.payment_ledger_account !== "Not Applicable" &&
            item.payment_ledger_account !== "End of List",
        )
        .map((item, index) => {
          const selectedPaymentLedger = findLedgerByIdOrName(
            payment_allocation_ledger_list,
            item?.payment_ledger_account_id,
            item?.payment_ledger_account || item?.ledger_name,
          );
          const isRowBillByBill =
            isPartyBillByBill ||
            isMaintainBillByBillEnabled(selectedPaymentLedger) ||
            isMaintainBillByBillEnabled(item);
          const cleanedAmount = cleanNumeric(item.payment_ledger_amount);
          const referenceNumber =
            item?.reference_no ||
            item?.bill_reference_no ||
            item?.bill_reference ||
            (isRowBillByBill ? `${referenceBase}-${index + 1}` : "");

          return {
            ...item,
            payment_ledger_amount: cleanedAmount,
            maintain_balance_bill_by_bill: isRowBillByBill ? "Yes" : "No",
            reference_no: referenceNumber,
            bill_reference_no: referenceNumber,
            reference_type:
              item?.reference_type || (isRowBillByBill ? "New Ref" : ""),
            bill_amount: isRowBillByBill ? cleanedAmount : "",
          };
        });

      const billWiseData = filteredPaymentAllocation
        .filter(
          (item) =>
            String(item?.maintain_balance_bill_by_bill || "").toLowerCase() ===
            "yes",
        )
        .map((item, index) => ({
          row_id: item?.id || `PA_${index + 1}`,
          ledger_id: item?.payment_ledger_account_id || "",
          ledger_name: item?.payment_ledger_account || item?.ledger_name || "",
          reference_no: item?.reference_no || item?.bill_reference_no || "",
          reference_type: item?.reference_type || "New Ref",
          bill_amount: item?.bill_amount || item?.payment_ledger_amount || "",
          allocated_amount: item?.payment_ledger_amount || "",
          is_bill_by_bill: "Yes",
        }));

      const cleanedData = {
        ...data,
        total_amount_item: cleanNumeric(data.total_amount_item),
        total_item_amt: cleanNumeric(data.total_item_amt),
        total_amount_allocate_party: cleanNumeric(
          data.total_amount_allocate_party,
        ),
        partry_bill_to_current_balance: cleanNumeric(
          data.partry_bill_to_current_balance,
        ),
        // Backend requires bill_to_address & ship_to_address (NOT NULL)
        bill_to_address: data.bill_to_address || data.bill_to_city || "",
        ship_to_address: data.ship_to_address || data.ship_to_city || "",
        data_item: (data.data_item || []).map((item) => ({
          ...item,
          item_qty: cleanNumeric(item.item_qty),
          item_rate: cleanNumeric(item.item_rate),
          item_amt: cleanNumeric(item.item_amt),
        })),
        sale_ledger_data: (data.sale_ledger_data || []).map((item) => ({
          ...item,
          ledger_amount: cleanNumeric(item.ledger_amount),
        })),
        payment_allocation: filteredPaymentAllocation,
        bill_wise_data: billWiseData,
        has_bill_wise_data: billWiseData.length > 0 ? "Yes" : "No",
      };
      return prepareFormData(cleanedData);
    },
    submitForm: (formData) =>
      dispatch(
        isAlter ? contraVoucherUpdate(formData) : contraVoucherCreate(formData),
      ),
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => handleSubmit(new Event("submit")),
      },
    ],
    resetForm: isAlter || isView ? () => navigate(-1) : resetForm,
    first_ref: inputRefs?.create_date,
    closeModal: () => {
      navigate(-1);
    },
    setSubmitConfirm,
    submitConfirm,
    setData,
    data,
    isView,
    isAlter,
    onPrintAfterSave: () => {
      dispatch(openModal("print"));
    },
    customFocusReset: () => {
      if (nameInput?.current) {
        nameInput.current.focus();
        nameInput.current.setSelectionRange(0, nameInput.current.value.length);
      } else if (nameInput?.focus) {
        nameInput.focus();
        nameInput.setSelectionRange(0, nameInput.value.length);
      }
    },
  });

  const handleClickOutside = (event) => {
    if (nameInput?.current) {
      event.preventDefault();
      nameInput.current.focus();
    } else if (nameInput?.focus) {
      event.preventDefault();
      nameInput.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (
      clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === "input" ||
        clickedElement?.tagName.toLowerCase() === "textarea")
    ) {
      clickedElement.focus();
    }
  };

  useClickOutside(nameInput, handleClickOutside, handleClickInside);

  if (modal_state?.ledgerCreate) {
    return (
      <LedgerCreate
        title="Ledger Creation (Secondary)"
        closeModal_sec={() => dispatch(closeModal("ledgerCreate"))}
      />
    );
  }

  if (modal_state?.godownCreateVoucher) {
    return (
      <GodownCreate
        title="Godown Creation (Secondary)"
        closeModal_sec={() => dispatch(closeModal("godownCreateVoucher"))}
      />
    );
  }

  if (modal_state?.stockItemCreate) {
    return (
      <StockItemCreate
        title="Stock Item Creation (Secondary)"
        closeModal_sec={async () => {
          try {
            await getItemList();
          } finally {
            dispatch(closeModal("stockItemCreate"));
          }
        }}
      />
    );
  }

  const isCreateMasterEnabled = Object.keys(modal_state).some(
    (key) =>
      modal_state[key] &&
      (key === "account" ||
        key === "party_bill_to" ||
        key === "party_ship_to" ||
        key === "location" ||
        key === "sale_purchase_ledger_account" ||
        key.startsWith("item_name") ||
        key.startsWith("ledger_account") ||
        key.startsWith("godown_location") ||
        key.startsWith("per_unit")),
  );

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleKeyDown={handleKeyDown}
        submitConfirm={submitConfirm}
        handleFocusReset={handleFocusReset}
        title={`${data?.voucher_type_name} Voucher ${isAlter ? "Alter" : isView ? "View" : isDuplicate ? "Duplication" : "Creation"}`}
        loading={submitting}
        col="col-12"
        Footer={MasterCreationFooter}
        createMasterEnabled={isCreateMasterEnabled}
        isAlter={isAlter}
        isView={isView}
      >
        {data?.dispatch_detail === "Available" &&
        modal_state?.dispatch_detail_modal ? (
          <DispatchDetails
            data={data}
            setData={setData}
            inputFields={inputFields}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
            inputRefs={inputRefs}
          />
        ) : null}
        {data?.order_detail === "Available" &&
        modal_state?.order_detail_modal ? (
          <OrderDetails
            data={data}
            setData={setData}
            inputFields={inputFields}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
            inputRefs={inputRefs}
            dynamicInputRef={dynamicInputRef}
          />
        ) : null}

        <div className="row p-0 m-0 mb-1">
          <div className="col-6">
            <div
              className="d-flex align-items-center"
              style={{ height: "3vh" }}
            >
              <label
                className="lab_voucher_entry"
                style={{ whiteSpace: "nowrap", flexShrink: 0, width: "auto" }}
              >
                {data?.voucher_type_name} No
              </label>
              <label style={{ flexShrink: 0, margin: "0 3px" }}>:</label>
              {inputFields
                .slice(0, 1)
                .map(({ label, name, type, isRequired, isDisabled }, index) => (
                  <input
                    key={name}
                    style={{ fontSize: 13, fontWeight: "bold", width: "25%" }}
                    type={type}
                    name={name}
                    id={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                    disabled={
                      isView ||
                      data?.method_of_voucher_number?.toLowerCase() !== "manual"
                    }
                  />
                ))}
            </div>
          </div>
          {inputFields
            .slice(1, 4)
            .map(({ label, name, type, isRequired }, index) => (
              <div className="col-6" key={name}>
                {index === 0 ? (
                  <div className="row justify-content-end">
                    <div className="col-6 d-flex justify-content-end">
                      {inputFields
                        .slice(1, 2)
                        .map(
                          (
                            { label, name, type, isRequired, autoFocus },
                            index,
                          ) => (
                            <React.Fragment key={name}>
                              <label className="pe-2">{data?.day_name}</label>
                              <input
                                style={{
                                  fontSize: 13,
                                  textAlign: "right",
                                  fontWeight: "bold",
                                  width: "38%",
                                  paddingRight: "2px",
                                }}
                                type={type}
                                name={name}
                                value={data[name] || ""}
                                onChange={handleChange}
                                onKeyUp={handleChange}
                                onBlur={handleBlur}
                                onFocus={handleFocus}
                                isRequired={isRequired}
                                ref={inputRefs[name]}
                                disabled={
                                  isView ||
                                  (name === "create_date" &&
                                    userData?.allowed_back_dated === "No")
                                }
                              />
                            </React.Fragment>
                          ),
                        )}
                    </div>
                  </div>
                ) : index === 1 ? (
                  <div
                    className="d-flex align-items-center"
                    style={{ height: "3vh" }}
                  >
                    {/* Supplier/Reference No */}
                    <label
                      style={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        fontSize: 13,
                      }}
                    >
                      {label}
                    </label>
                    <label
                      style={{ flexShrink: 0, margin: "0 3px", fontSize: 13 }}
                    >
                      :
                    </label>
                    <input
                      style={{ fontSize: 13, fontWeight: "bold", width: "35%" }}
                      type={type}
                      name={name}
                      value={data[name] || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      ref={inputRefs[name]}
                    />
                    {/* Date - inline right after */}
                    <label
                      style={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        fontSize: 13,
                        marginLeft: "12px",
                      }}
                    >
                      {inputFields[3].label}
                    </label>
                    <label
                      style={{ flexShrink: 0, margin: "0 3px", fontSize: 13 }}
                    >
                      :
                    </label>
                    <input
                      style={{ fontSize: 13, fontWeight: "bold", width: "20%" }}
                      type={inputFields[3].type}
                      name={inputFields[3].name}
                      value={data[inputFields[3].name] || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      ref={inputRefs[inputFields[3].name]}
                    />
                  </div>
                ) : null}
              </div>
            ))}
        </div>
        <div className="row p-0 m-0 pb-1 ">
          <div className="col-6">
            {inputFields
              .slice(4, 9)
              .map(({ label, name, type, isRequired }, index) => (
                <InputField
                  height="3vh"
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={data[name] || ""}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  ref={inputRefs[name]}
                />
              ))}

            {Object.entries(dropdownConfig).map(
              ([key, config]) =>
                modal_state?.[key] &&
                key !== "party_ship_to" &&
                key !== "dispatch_detail" &&
                key !== "order_detail" && (
                  <DropdownLayout_1
                    key={key}
                    title={config.title}
                    state={modal_state[key]}
                    data={data}
                    setData={setData}
                    input_value={data[key]}
                    input_key={key}
                    input_id={config?.input_id}
                    rawData={config.data}
                    ref={inputRefs[key]}
                    inputRefs={inputRefs}
                    setSubmitConfirm={setSubmitConfirm}
                    handleDropdownClick={handleDropdownClick}
                    loading={isListLoading}
                  />
                ),
            )}
          </div>
          <div className="col-6">
            {inputFields
              .slice(9, 14)
              .map(({ label, name, type, isRequired }, index) => {
                if (name === "party_ship_to") {
                  return (
                    <div
                      key={index}
                      className="row m-0 p-0 position-relative"
                      style={{ height: "3vh" }}
                    >
                      <div className={`col-5 m-0 p-0 text-start text-truncate`}>
                        <label>{label}</label>
                      </div>
                      <div className=" m-0 p-0" style={{ width: "2%" }}>
                        <label> :</label>
                      </div>
                      <div
                        className={`col-6 p-0 m-0 text-start`}
                        // style={{ position: "relative" }}
                      >
                        <input
                          style={{
                            fontSize: 13,
                            fontWeight: "bold",
                            width: "100%",
                          }}
                          type={type}
                          autoComplete="off"
                          disabled={isView}
                          className={false ? "text-muted" : ""}
                          autoFocus={false}
                          name={name}
                          id={name}
                          value={data[name] || ""}
                          onKeyUp={handleChange}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onFocus={handleFocus}
                          ref={inputRefs[name]}
                        />
                      </div>
                      {Object.entries(dropdownConfig).map(
                        ([key, config]) =>
                          modal_state?.[key] &&
                          key === "party_ship_to" && (
                            <DropdownLayout_1
                              className="dropdown-content-list_custom"
                              key={key}
                              title={config.title}
                              state={modal_state[key]}
                              data={data}
                              setData={setData}
                              input_value={data[key]}
                              input_key={key}
                              input_id={config?.input_id}
                              rawData={config.data}
                              ref={inputRefs[key]}
                              inputRefs={inputRefs}
                              setSubmitConfirm={setSubmitConfirm}
                              handleDropdownClick={handleDropdownClick}
                            />
                          ),
                      )}
                    </div>
                  );
                } else {
                  return (
                    <InputField
                      height="3vh"
                      key={index}
                      lable={label}
                      type={type}
                      name={name}
                      value={data[name] || ""}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleFocus={handleFocus}
                      ref={inputRefs[name]}
                    />
                  );
                }
              })}
          </div>
        </div>
        <div className="row p-0 m-0 pb-1 mb-1" style={{ height: "3vh" }}>
          {inputFields
            .slice(14, 17)
            .map(({ label, name, type, isRequired }, index) => {
              // Custom per-field flex config
              const isDispatch = name === "dispatch_detail";
              const isLedger = name === "sale_purchase_ledger_account";
              return (
                <div
                  className={`col-3${isDispatch ? " position-relative" : ""}`}
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "3vh",
                    overflow: "hidden",
                  }}
                >
                  {/* Label — auto width, no excess gap */}
                  <label
                    style={{
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      fontSize: 12,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: isLedger ? "54%" : undefined,
                    }}
                  >
                    {label}
                  </label>
                  {/* Colon — tight, no gap */}
                  <span
                    style={{ flexShrink: 0, margin: "0 2px", fontSize: 12 }}
                  >
                    :
                  </span>
                  {/* Input — fills remaining or capped for dispatch */}
                  <input
                    style={{
                      flex: isDispatch ? "0 0 auto" : "1 1 0",
                      width: isDispatch ? "43%" : "100%",
                      minWidth: 0,
                      fontSize: 13,
                      fontWeight: "bold",
                    }}
                    type={type}
                    autoComplete="off"
                    disabled={isView}
                    name={name}
                    id={name}
                    value={data[name] || ""}
                    onKeyUp={handleChange}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    ref={inputRefs[name]}
                  />
                  {/* Dispatch dropdown */}
                  {isDispatch &&
                    Object.entries(dropdownConfig).map(
                      ([key, config]) =>
                        modal_state?.[key] &&
                        key === "dispatch_detail" && (
                          <DropdownLayout_1
                            key={key}
                            className="dropdown-content-list_custom"
                            title={config.title}
                            state={modal_state[key]}
                            data={data}
                            setData={setData}
                            input_value={data[key]}
                            input_key={key}
                            input_id={config?.input_id}
                            rawData={config.data}
                            ref={inputRefs[key]}
                            inputRefs={inputRefs}
                            setSubmitConfirm={setSubmitConfirm}
                            handleDropdownClick={handleDropdownClick}
                          />
                        ),
                    )}
                </div>
              );
            })}
          {inputFields
            .slice(26, 27)
            .map(({ label, name, type, isRequired }, index) => {
              if (name === "order_detail") {
                return (
                  <div
                    className="col-3 position-relative"
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "3vh",
                      overflow: "hidden",
                    }}
                  >
                    <label
                      style={{
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        fontSize: 12,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "58%",
                      }}
                    >
                      {label}
                    </label>
                    <span
                      style={{ flexShrink: 0, margin: "0 2px", fontSize: 12 }}
                    >
                      :
                    </span>
                    <input
                      style={{
                        flex: "0 0 auto",
                        width: "37%",
                        minWidth: 0,
                        fontSize: 13,
                        fontWeight: "bold",
                      }}
                      type={type}
                      autoComplete="off"
                      disabled={isView}
                      name={name}
                      id={name}
                      value={data[name] || ""}
                      onKeyUp={handleChange}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onFocus={handleFocus}
                      ref={inputRefs[name]}
                    />
                    {Object.entries(dropdownConfig).map(
                      ([key, config]) =>
                        modal_state?.[key] &&
                        key === "order_detail" && (
                          <DropdownLayout_1
                            className="dropdown-content-list_custom"
                            key={key}
                            title={config.title}
                            state={modal_state[key]}
                            data={data}
                            setData={setData}
                            input_value={data[key]}
                            input_key={key}
                            input_id={config?.input_id}
                            rawData={config.data}
                            ref={inputRefs[key]}
                            inputRefs={inputRefs}
                            setSubmitConfirm={setSubmitConfirm}
                            handleDropdownClick={handleDropdownClick}
                          />
                        ),
                    )}
                  </div>
                );
              }
            })}
        </div>
        <TableHeaderSalePurchase data={data} />
        <VoucherSalesPurchaseInputRow
          data={data}
          setData={setData}
          itemData={[{ id: "ed", name: "End of List" }, ...(itemList || [])]}
          itemLedgerData={[
            { id: "ed", ledger_name: "End of List" },
            ...(itemLedgerData || []),
          ]}
          godownLocationItem={godownLocation?.item || []}
          handleChange={handleItemUpdate}
          handleFocus={handleDynamicFocus}
          handleBlur={handleDynamicBlur}
          inputRefs={dynamicInputRef}
          dynamicInputRef_expenses={dynamicInputRef_expenses}
          handleDropdownDynamicClick={handleDropdownDynamicClick}
          handleKeyDown={handleKeyDown}
          isItemLoading={isItemLoading}
          isGodownLoading={isGodownLoading}
          isListLoading={isListLoading}
        />
        <Total_Amount_Row_Sell_Purchase data={data} />

        <div
          className="row p-0 pb-2 m-0 border_2_1px_top"
          style={{ width: "100%" }}
        >
          <div className="col-6 m-0 p-0 ps-1 text-start">
            {inputFields
              .slice(31)
              .map(({ label, name, type, isRequired }, index) => (
                <React.Fragment key={index}>
                  <label className="ps-2">{label} </label>
                  <div className="d-flex justify-content-between align-item-center">
                    <textarea
                      style={{ height: "7.5vh" }}
                      key={index}
                      lable={label}
                      className="narration_input"
                      type={type}
                      name={name}
                      value={data[name] || ""}
                      onKeyUp={handleChange}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      isRequired={isRequired}
                      ref={inputRefs[name]}
                      disabled={isView}
                    />
                  </div>
                </React.Fragment>
              ))}
          </div>
          {(isView
            ? (data?.payment_allocation || []).filter(
                (item) =>
                  item.payment_ledger_account &&
                  item.payment_ledger_account !== "Not Applicable" &&
                  item.payment_ledger_account !== "End of List"
              ).length > 0
            : true) && (
          <div className="col-6 m-0 p-0 ps-1 text-start border_2_1px_left">
            <label style={{ paddingLeft: "4%" }}>Payment Allocation</label>
            {/* {
                            data?.total_amount_item > 0 && ( */}
            <PaymentAllocation
              data={data}
              setData={setData}
              handleChange={handleItemUpdate}
              handleBlur={handleDynamicBlur}
              handleFocus={handleDynamicFocus}
              inputRefs={dynamicInputRef_payment_allocation}
              isView={isView}
              itemLedgerData={[
                { id: "ed", ledger_name: "Not Applicable" },
                ...(payment_allocation_ledger_list || []),
              ]}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleKeyDown={handleKeyDown}
              loading={isListLoading}
            />

            {/* //     )
                        // } */}
            <div
              className="border_2_1px_top border_2_1px_bottom"
              style={{ display: "flex", alignItems: "center", height: 25 }}
            >
              <div style={{ width: "4%", flexShrink: 0 }}></div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <label className="font_size">{data?.party_bill_to}</label>
              </div>
              <div style={{ width: "4%", flexShrink: 0 }}></div>
              <div
                style={{
                  width: 120,
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  paddingRight: 5,
                  whiteSpace: "nowrap",
                  fontSize: 13,
                }}
              >
                {data?.total_amount_allocate_party
                  ? currencyFormate(data?.total_amount_allocate_party)
                  : ""}
              </div>
            </div>
          </div>
          )}
        </div>
      </Form>
    </>
  );
};

export default Sales;
